import { Navigate, Route, Routes } from 'react-router';
import { LoginPage } from '../auth/LoginPage';
import { useSession } from '../auth/session';
import { ProjectDetailPage } from '../projects/ProjectDetailPage';
import { ProjectListPage } from '../projects/ProjectListPage';
import { RoleListPage } from '../roles/RoleListPage';
import { AppLayout } from './AppLayout';
import { LandingRedirect } from './LandingRedirect';
import { ProtectedRoute } from './ProtectedRoute';
import { RequirePermission } from './RequirePermission';

/**
 * Uygulamanın ROTA AĞACI — main.tsx'ten ayrı bir dosyada, çünkü testler de bu
 * ağacı kullanmalı (SEOAI-80 ikinci inceleme).
 *
 * Bileşenleri tek tek render eden testler, ancak baktıkları parçayı ölçer:
 * TenantGate tek başına doğru davranırken başlıktaki kurum değiştirici aynı
 * isteği yapıyordu ve hiçbir test bunu görmüyordu. Kabuğun TAMAMI üzerinden
 * koşan bir test, "hangi uçlara gidildi" sorusunu gerçekten yanıtlar.
 */

export function AppRoutes() {
  const tokens = useSession((state) => state.tokens);

  return (
    <Routes>
      {/*
        * Giriş yapmış kullanıcı köke gider; hedefi LandingRedirect ÇÖZER.
        * Sabit /projects idi ve project.view izni olmayan kullanıcıyı her
        * seferinde Forbidden ekranına düşürüyordu (inceleme bulgusu).
        */}
      <Route path="/login" element={tokens ? <Navigate to="/" replace /> : <LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        {/* Açılış: erişilebilir ilk bölüm (izinler yüklendikten sonra çözülür). */}
        <Route index element={<LandingRedirect />} />

        {/*
          * Sayfa guard'ları (SEOAI-47). URL elle yazılsa bile backend 403 döner;
          * buradaki kontrol kullanıcıyı kırık bir ekranla baş başa bırakmamak için.
          */}
        <Route
          path="/projects"
          element={
            <RequirePermission permission="project.view">
              <ProjectListPage />
            </RequirePermission>
          }
        />
        <Route
          path="/projects/:projectId"
          element={
            <RequirePermission permission="project.view">
              <ProjectDetailPage />
            </RequirePermission>
          }
        />
        <Route
          path="/roles"
          element={
            <RequirePermission permission="role.view">
              <RoleListPage />
            </RequirePermission>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
